import { render } from "./boyaaSubjectFusion.vue?vue&type=template&id=561b6a9f&scoped=true"
import script from "./boyaaSubjectFusion.vue?vue&type=script&lang=js"
export * from "./boyaaSubjectFusion.vue?vue&type=script&lang=js"

import "./boyaaSubjectFusion.vue?vue&type=style&index=0&id=561b6a9f&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561b6a9f"]])

export default __exports__